import PlayerSlotInterface from "@/types/PlayerSlotInterface";
import SlotTag from "@/types/SlotTag";

export default class PlayerSlot implements Partial<PlayerSlotInterface> {
    public name: string = "";
    public description: string = "";
    public leader: boolean = false;
    public lottery: boolean = false;
    public tags?: SlotTag[] | string[] = [];

    constructor (
        name: string = "",
        description: string = "",
        leader: boolean = false,
        lottery: boolean = false,
        tags?: SlotTag[] | string[]
      ) {
        this.name = name;
        this.description = description;
        this.leader = leader;
        this.lottery = lottery;
        this.tags = tags;
      }
}
